import { render, staticRenderFns } from "./welcome3.vue?vue&type=template&id=584ff6e6&scoped=true"
import script from "./welcome3.vue?vue&type=script&lang=js"
export * from "./welcome3.vue?vue&type=script&lang=js"
import style0 from "./welcome3.vue?vue&type=style&index=0&id=584ff6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ff6e6",
  null
  
)

export default component.exports